import { render } from "./WelcomeFractal.vue?vue&type=template&id=4cd010a2&scoped=true"
import script from "./WelcomeFractal.vue?vue&type=script&lang=js"
export * from "./WelcomeFractal.vue?vue&type=script&lang=js"

import "./WelcomeFractal.vue?vue&type=style&index=0&id=4cd010a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd010a2"]])

export default __exports__